import { render } from "./BetLimit.vue?vue&type=template&id=0820e41e"
import script from "./BetLimit.vue?vue&type=script&lang=js"
export * from "./BetLimit.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__